<template>
  <v-container fluid pa-0 mt-0 fill-height>
    <v-layout wrap row justify-content-center>
      <rHeader
        v-if="globals"
        :title_first_line="$t(globals.header)"
        :title_second_line="$t(globals.header2)"
        :herb_image="globals.herb"
        :header_image="globals.topimage"
      ></rHeader>
      <v-flex xl10 md10 sm12 xs12 >
        <router-link to="/">
          <v-btn block color="info">{{ $t('back_to_homepage') }}</v-btn>
        </router-link>
        
        <v-card v-if="!apiInfo">
          <v-card-title>
            <h2>{{ $t('cancelled_progress') }}</h2>
          </v-card-title>
        </v-card>
        <v-card v-if="apiInfo && apiInfo.UPDATEINFO">
          <v-card-title>
            <h2 class="text-danger">{{ $t('cancelled') }}</h2>
          </v-card-title>
        </v-card>
        <v-card v-if="apiInfo && apiInfo.ERROR">
          <v-card-title>
            <h2 class="text-danger">{{ apiInfo.ERROR }}</h2>
            <hr>
            <h5 class="text-danger">{{ apiInfo.ERROREX }}</h5>
          </v-card-title>
        </v-card>
      </v-flex>
      <rFooter :footer_left="$t(globals.footer_left)" :footer_right="$t(globals.footer_right)"></rFooter>
    </v-layout>
  </v-container>
</template>

<script>
import RemoteData from "../mixins/remotedata";
import Utilities from "../mixins/utilities";
export default {
  name: "CancelPage",
  data: function() {
    return {
      apiInfo: null,
    };
  },
  props: ["globals"],
  mixins: [
    RemoteData({
      apiInfo() {
        return [`${env.apiLinks.cancel}${this.$route.params.hash}`, false];
      }
    }),
    Utilities
  ]
}
</script>

<style scoped>
.v-btn {
  height: auto;
  flex-flow: row wrap;
  padding: 0.5rem;
}

.v-btn /deep/ p {
  width: 100%;
  margin-bottom: 0.1rem;
}

.v-btn /deep/ span {
  width: 100%;
}

.v-btn{
  height: auto;
}

.v-btn /deep/ .v-btn__content{
  white-space: pre-line !important;
}

.v-btn:hover {
  text-decoration: none;
}
</style>